import {
  DOWNLOAD_ABSENCE_ATTACHMENT_WITHOUT_MODAL,
  EMPLOYEE_ABSENCES_ERROR,
  EMPLOYEE_ABSENCES_REQUEST,
  EMPLOYEE_ABSENCES_SUCCESS,
  RESET_VACATION_MODAL_DATA,
  SET_EDIT_LEAVE_MODAL_DATA,
  SET_LEAVE_MODAL_MAIN_DATA,
  TOGGLE_VACATION_MODAL_VISIBILITY,
  SET_TABLE_DEFAULT_PAGE,
} from 'modules/SalaryModule/Vacations/actions';
import {
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
  STATUS_ERROR,
  STATUS_LOADING,
} from 'const';

const initialState = {
  isModalVisible: false,
  vacationModalData: null,
  submitType: 'create',
  leaveObjId: null,
  startDate: null,
  employeeAbsences: [],
  status: STATUS_NOT_REQUESTED,
  tableDefaultPage: 1,
};

export const vacationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_VACATION_MODAL_VISIBILITY:
      return {
        ...state,
        isModalVisible: !state.isModalVisible,
      };

    case SET_LEAVE_MODAL_MAIN_DATA: {
      const { startDate, ...vacationModalData } = action.payload;
      return {
        ...state,
        vacationModalData,
        startDate: startDate || null,
      };
    }

    case SET_EDIT_LEAVE_MODAL_DATA: {
      const { submitType, leaveObjId } = action.payload;
      return {
        ...state,
        submitType,
        leaveObjId,
      };
    }

    case RESET_VACATION_MODAL_DATA:
      return initialState;

    case DOWNLOAD_ABSENCE_ATTACHMENT_WITHOUT_MODAL: {
      const { leaveObjId } = action.payload;
      return {
        ...state,
        leaveObjId,
      };
    }

    case EMPLOYEE_ABSENCES_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
      };

    case EMPLOYEE_ABSENCES_SUCCESS:
      return {
        ...state,
        status: STATUS_SUCCESS,
        employeeAbsences: action.payload.absences,
      };

    case EMPLOYEE_ABSENCES_ERROR:
      return {
        ...state,
        status: STATUS_ERROR,
      };

    case SET_TABLE_DEFAULT_PAGE:
      return {
        ...state,
        tableDefaultPage: action.payload,
      };

    default:
      return state;
  }
};
